import { render, staticRenderFns } from "./HorizontalPosterMockup.vue?vue&type=template&id=1eb89cb2&"
import script from "./HorizontalPosterMockup.vue?vue&type=script&lang=js&"
export * from "./HorizontalPosterMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports